import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import chatList, { getChatListSaga } from 'modules/actions/chat';
import fontSize from 'modules/actions/fontSize';
import deviceEnv from 'modules/actions/deviceEnv';
import feedBack from 'modules/actions/feedBack';
import selectBox from 'modules/actions/selectBox';
import autoComplete, { autoCompleteSaga } from 'modules/actions/autoComplete/index';
import isActive from 'modules/actions/statusMenu/index';
import tts from 'modules/actions/tts/index';
import iosTTS from 'modules/actions/iosTTS/index';
import dementia from 'modules/actions/dementia/index';
import organization, {organizSaga} from 'modules/actions/organization/index';
import twoDept, {twoDeptSaga} from 'modules/actions/twoDept/index';

const rootReducer = combineReducers({
  autoComplete,
  isActive,
  chatList,
  fontSize,
  feedBack,
  selectBox,
  deviceEnv,
  tts,
  dementia,
  organization,
  twoDept,
  iosTTS,
});

export function* rootSaga() {
  // yield all([autoCompleteSaga(), getChatListSaga()]);
  yield all([autoCompleteSaga(), getChatListSaga(), organizSaga(),twoDeptSaga()]);
}

export default rootReducer;
